import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findValueInJsonByPatientLookup',
})
export class FindValueInJsonByKeyPipe implements PipeTransform {
  transform(TransactionForm: any): any {
    const key = this.isThereLookupPatient(JSON.parse(TransactionForm?.form?.schema));
    if (key) {
      return JSON.parse(TransactionForm?.input_data)[key];
    }
    return;
  }

  private isThereLookupPatient(obj: any): any {
    if (!obj || typeof obj !== 'object') {
      return false;
    }

    if ('lookup' in obj) {
      return obj.lookup === 'PATIENT' ? obj.key : '';
    }

    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = this.isThereLookupPatient(obj[prop]);
        if (value !== undefined) {
          return value;
        }
      }
    }
    return undefined;
  }
}
